import React from 'react'
import './capacity.css'

const CapacityView = ({age_group, number_of_places}) => (
  <dl className="details-card-list">
    <dt>Age group</dt>
    <dd>{age_group}</dd>
    <dt>Number of places</dt>
    <dd>{number_of_places}</dd>
  </dl>
)

export default CapacityView


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/views/capacity/view.jsx